<div class="duna-event-price-templates-container">
  <mat-card class="header-card">
    <mat-card-header>
      <mat-card-title><h1>Kursusprisskabeloner</h1></mat-card-title>
      <mat-card-subtitle>
        Konfigurer priser og price-extras for hver prisgruppe i skabelonen. Vælges i add/edit-event under Pris.
      </mat-card-subtitle>
    </mat-card-header>
  </mat-card>

  @if (errorMessage) {
    <mat-card class="message-card message-card--error">
      <mat-card-content>
        <p class="error-message">{{ errorMessage }}</p>
      </mat-card-content>
    </mat-card>
  }

  <mat-card class="search-card">
    <mat-card-content>
      <div class="create-row">
        <mat-form-field appearance="outline" class="field-label" subscriptSizing="dynamic">
          <mat-label>Tekst</mat-label>
          <textarea
            matInput
            rows="2"
            [(ngModel)]="newLabel"
            placeholder="Fx standard kursuspris"
            [disabled]="creating || loading"></textarea>
        </mat-form-field>
        <div class="create-actions">
          <button mat-raised-button color="primary" type="button" (click)="createTemplate()" [disabled]="creating || loading || priceGroups.length === 0">
            {{ creating ? 'Opretter…' : 'Tilføj' }}
          </button>
          <button mat-stroked-button type="button" (click)="load()" [disabled]="loading || creating">
            <mat-icon>refresh</mat-icon>
            {{ loading ? 'Henter…' : 'Opdater' }}
          </button>
        </div>
      </div>
      @if (!loading && priceGroups.length === 0) {
        <p class="hint">Opret prisgrupper under organisationsindstillinger → Ressourcer først.</p>
      }
    </mat-card-content>
  </mat-card>

  <mat-card class="table-card">
    <mat-card-header>
      <mat-card-title>Gemte prisskabeloner</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (loading) {
        <div class="state">Henter skabeloner…</div>
      } @else if (templates.length === 0) {
        <div class="state">Ingen prisskabeloner endnu.</div>
      } @else {
        <mat-accordion multi>
          @for (row of templates; track row.id) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>{{ draftById[row.id]?.label || row.label }}</mat-panel-title>
                <mat-panel-description>
                  <mat-slide-toggle
                    [checked]="row.is_active"
                    [disabled]="togglingId === row.id"
                    (click)="$event.stopPropagation()"
                    (change)="onActiveChange(row, $event)">
                  </mat-slide-toggle>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div class="template-editor">
                <mat-form-field appearance="outline" class="field-label" subscriptSizing="dynamic">
                  <mat-label>Tekst</mat-label>
                  <textarea
                    matInput
                    rows="2"
                    [(ngModel)]="draftById[row.id].label"
                    [disabled]="savingId === row.id"></textarea>
                </mat-form-field>

                <h4>Priser og price-extras per prisgruppe</h4>
                @if (extraOptions.length === 0) {
                  <p class="hint">Ingen price-extras i kataloget — kun priser kan sættes her.</p>
                }

                <div class="group-blocks">
                  @for (group of priceGroups; track group.id) {
                    <section class="group-block">
                      <h5 class="group-block-title">{{ group.label }}</h5>
                      <div class="matrix-row matrix-row--prices">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                          <mat-label>Fastsat beløb (kr.)</mat-label>
                          <input
                            matInput
                            type="number"
                            min="0"
                            step="0.01"
                            [(ngModel)]="draftById[row.id].pricesByGroupId[group.id].fixed_course_amount">
                        </mat-form-field>
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                          <mat-label>Per deltagelse (kr.)</mat-label>
                          <input
                            matInput
                            type="number"
                            min="0"
                            step="0.01"
                            [(ngModel)]="draftById[row.id].pricesByGroupId[group.id].per_participant_amount">
                        </mat-form-field>
                      </div>
                      @if (extraOptions.length > 0) {
                        <div class="extras-list">
                          <span class="extras-label">Price-extras for denne prisgruppe:</span>
                          @for (extra of extraOptions; track extra.id) {
                            <mat-checkbox
                              [checked]="isExtraSelected(row.id, group.id, extra.id)"
                              (change)="toggleExtra(row.id, group.id, extra.id, $event.checked)">
                              {{ extra.label }}
                            </mat-checkbox>
                          }
                        </div>
                      }
                    </section>
                  }
                </div>

                <div class="actions-row">
                  <button
                    mat-stroked-button
                    color="primary"
                    type="button"
                    (click)="saveRow(row)"
                    [disabled]="savingId === row.id || !rowDirty(row)">
                    <mat-icon>save</mat-icon>
                    {{ savingId === row.id ? 'Gemmer…' : 'Gem' }}
                  </button>
                  <button
                    mat-stroked-button
                    color="warn"
                    type="button"
                    (click)="deleteTemplate(row)"
                    [disabled]="deletingId === row.id">
                    <mat-icon>{{ deletingId === row.id ? 'hourglass_top' : 'delete' }}</mat-icon>
                    {{ deletingId === row.id ? 'Sletter…' : 'Slet' }}
                  </button>
                </div>
              </div>
            </mat-expansion-panel>
          }
        </mat-accordion>
      }
    </mat-card-content>
  </mat-card>
</div>
